import backdrop_obj from './flowConfig/backdrop'
import node_sub_proc_obj from './flowConfig/node_sub_proc'
import node_serial_obj from './flowConfig/node_serial'
import node_parallel_obj from './flowConfig/node_parallel'
import node_normal_obj from './flowConfig/node_normal'
import node_end_obj from './flowConfig/node_end'
import node_start_obj from './flowConfig/node_start'
import line_normal_obj from './flowConfig/line_normal'
import node_circular_obj from './flowConfig/node_circular'
import node_fork_serial_obj from './flowConfig/node_fork_serial'
import node_fork_parallel_obj from './flowConfig/node_fork_parallel'
import node_fork_join_obj from './flowConfig/node_fork_join'
import node_dynamic_obj from './flowConfig/node_dynamic'

export default function (Vue, parent, _data) {
  var backdrop =backdrop_obj(Vue,parent,_data)
  var node_sub_proc=node_sub_proc_obj(Vue,parent,_data)
  var node_serial = node_serial_obj(Vue,parent,_data)
  var node_parallel = node_parallel_obj(Vue,parent,_data)
  var node_normal = node_normal_obj(Vue,parent,_data)
  var node_end = node_end_obj(Vue,parent,_data)
  var node_start = node_start_obj(Vue,parent,_data)
  var line_normal = line_normal_obj(Vue,parent,_data)

  var node_circular = node_circular_obj(Vue, parent, _data)
  var node_fork_serial = node_fork_serial_obj(Vue,parent,_data)
  var node_fork_parallel = node_fork_parallel_obj(Vue,parent,_data)
  var node_fork_join = node_fork_join_obj(Vue,parent,_data)
  var node_dynamic = node_dynamic_obj(Vue,parent,_data)

  var nodeParams={}
  var lineParams={}
  var content={};
  var config=parent.config;
  if(config && config.formId && config.content && config.content[config.formId]){
    content=config.content[config.formId];
  }

  var backdropParams={
    editable:parent.editable,
    key:_data.data.key,
    content:content
  }
  var types=[];
  parent.activityTypes.map((v)=>{
    var s=v.split("|");
    types.push({label:s[0],value:s[1]})
  })
  nodeParams.sysId=parent.sysId;
  nodeParams.applicationId=_data.data.applicationId||parent.appId;
  nodeParams.processDefinitionId=_data.data.id;
  nodeParams.editable=parent.editable;
  nodeParams.moduleId = parent.moduleId;
  if(config){
    nodeParams.flowMarks = config.flowMarks || "";
    lineParams.flowMarks = config.flowMarks || "";
  }
  lineParams.processDefinitionId=_data.data.id;
  lineParams.applicationId=_data.data.applicationId||parent.appId;
  lineParams.editable=parent.editable;
  lineParams.moduleId = parent.moduleId;
  nodeParams.changeType=function(val){
    parent.$configVue.type = 'node-' + val
  }
  nodeParams.activityTypes=types;
  nodeParams.processDataItems=_data.data.items;

  lineParams.processDataItems=_data.data.items;

  parent.$configVue = new Vue({
    el: '#mw-process-chart-config',
    template: `<div id="mw-process-chart-config"><component :is="type" :data="data" :params="params"></component></div>`,
    components: {
      'backdrop': backdrop,
      'node-sub-proc': node_sub_proc,
      'node-serial': node_serial,
      'node-parallel': node_parallel,
      'node-normal': node_normal,
      'node-end': node_end,
      'node-start': node_start,
      'line-normal': line_normal,
      'node-circular':node_circular,
      'node-fork-serial':node_fork_serial,
      'node-fork-parallel':node_fork_parallel,
      'node-fork-join':node_fork_join,
      'node-dynamic':node_dynamic,
    },
    data() {
      return {
        type: '',
        data: {},
        params:{}
      }
    },
    mounted() {
      var me = this;
      var processData = _data.data
      me.type='backdrop';
      me.data = processData.parameters;

      if (config.fieldMapping.businessName == undefined) {
        this.$set(me.data, 'businessName', '');
      }else{
        this.$set(me.data, 'businessName', config.fieldMapping.businessName);
      }
      if (config.fieldMapping.businessKeyword == undefined) {
        this.$set(me.data, 'businessKeyword', '');
      }else{
        this.$set(me.data, 'businessKeyword', config.fieldMapping.businessKeyword);
      }
      if (config.fieldMapping.businessCategory == undefined) {
        this.$set(me.data, 'businessCategory', '');
      }else{
        this.$set(me.data, 'businessCategory', config.fieldMapping.businessCategory);
      }
      if (config.fieldMapping.urgencyLevel == undefined) {
        this.$set(me.data, 'urgencyLevel', '');
      }else{
        this.$set(me.data, 'urgencyLevel', config.fieldMapping.urgencyLevel);
      }
      backdropParams.id=processData.id;
      me.params=backdropParams;


      var items = processData.items

      var activity = items.ACTIVITY;
      var sequence = items['SEQUENCE-FLOW'];
      parent.$off([['node:append','node:remove','node:click','line:update','line:append','line:remove','line:click','backdrop:click','clear']])

      // 添加节点
      parent.$on('node:append', function (data) {
        var n = {id: data.id, extends: data.type, parameters: {id: data.id, type: data.type}};
        activity.push(n);
      });

      //移除节点
      parent.$on('node:remove', function (data) {
        for (var i = 0; i < activity.length; i++) {
          var v = activity[i];
          if (v.id == data.id) {
            activity.splice(i, 1);
            break
          }
        }
      });

      //点击节点
      parent.$on('node:click', function (data) {
        for (var i = 0; i < activity.length; i++) {
          var v = activity[i];
          if (v.id == data.id) {
            me.type = 'node-' + v.parameters.type
            //me.type = 'node-'+data.type
            if (v.parameters.name == undefined) {
              delete v.parameters.name
            }
            me.data = v.parameters;
            me.params=nodeParams;
            break;
          }
        }
      });

      //添加连线
      parent.$on('line:append', function (data) {
        data.type = 'normal';
        var from=data.sourceShapeId;
        var to=data.targetShapeId;
        var n = {
          id: data.id,
          sourceId: from,
          targetId: to,
          type: data.type,
          tip:data.tip,
          parameters: {id: data.id, from: from, to: to, type: data.type, tip:data.tip}
        }
        sequence.push(n)
      });

      parent.$on('line:update', function (data) {
        var from=data.sourceShapeId;
        var to=data.targetShapeId;
        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];


          v.sourceId=from;
          v.targetId=to;


          if (v.id == data.id) {
            me.type = 'line-normal'
            if (v.parameters.name == undefined) {
              delete v.parameters.name
            }
            v.parameters.from=from;
            v.parameters.to=to;

            me.data = v.parameters;
            var fromFlag = false;
            var toFlag = false;
            for (var j = 0; j < activity.length; j++) {
              var a = activity[j];

              if (!fromFlag && a.id == me.data.from) {
                lineParams.fromName=a.parameters.name;
                fromFlag = true;
              }
              if (!toFlag&& a.id == me.data.to) {
                lineParams.toName=a.parameters.name;
                toFlag = true;
              }
              if(fromFlag && toFlag){
                break;
              }
            }
            me.params=lineParams;
            break;
          }
        }

      })

      //移除连线
      parent.$on('line:remove', function (data) {
        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];
          if (v.id == data.id) {
            sequence.splice(i, 1);
            break
          }
        }
      });

      //点击连线
      parent.$on('line:click', function (data) {

        for (var i = 0; i < sequence.length; i++) {
          var v = sequence[i];
          if (v.id == data.id) {
            me.type = 'line-normal'
            if (v.parameters.name == undefined) {
              delete v.parameters.name
            }
            me.data = v.parameters;
            var fromFlag = false;
            var toFlag = false;
            for (var j = 0; j < activity.length; j++) {
              var a = activity[j];

              if (!fromFlag && a.id == me.data.from) {
                lineParams.fromName=a.parameters.name;
                fromFlag = true;
              }
              if (!toFlag&& a.id == me.data.to) {
                lineParams.toName=a.parameters.name;
                toFlag = true;
              }
              if(fromFlag && toFlag){
                break;
              }
            }
            me.params=lineParams;
            break;
          }
        }
      });

      //点击背景
      parent.$on('backdrop:click', function (data) {
        me.type = 'backdrop';
        me.data = processData.parameters;
        me.params=backdropParams;
      });

      parent.$on('clear', function (data) {
        items.ACTIVITY=[];
        activity=items.ACTIVITY;
        items['SEQUENCE-FLOW']=[];
        sequence=items['SEQUENCE-FLOW'];
      });


    }
  })

}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flow-config.js